/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFareFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeFare, serializeFareCreateRequest, serializeFareUpdateRequest, type Fare, type FareCreateRequest, type FareUpdateRequest, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { CreateCsvRequestBuilderRequestsMetadata, type CreateCsvRequestBuilder } from './createCsv/index.js';
// @ts-ignore
import { GetRequestBuilderRequestsMetadata, type GetRequestBuilder } from './get/index.js';
// @ts-ignore
import { FareItemRequestBuilderNavigationMetadata, FareItemRequestBuilderRequestsMetadata, type FareItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Fare
 */
export interface FareRequestBuilder extends BaseRequestBuilder<FareRequestBuilder> {
    /**
     * The CreateCsv property
     */
    get createCsv(): CreateCsvRequestBuilder;
    /**
     * The GetPath property
     */
    get getPath(): GetRequestBuilder;
    /**
     * Gets an item from the ApiSdk.Fare.item collection
     * @param id Unique identifier of the item
     * @returns {FareItemRequestBuilder}
     */
     byId(id: number) : FareItemRequestBuilder;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Fare>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     post(body: FareCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Fare | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     put(body: FareUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: FareCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: FareUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const FareRequestBuilderUriTemplate = "{+baseurl}/Fare";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const FareRequestBuilderNavigationMetadata: Record<Exclude<keyof FareRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: FareItemRequestBuilderRequestsMetadata,
        navigationMetadata: FareItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
    createCsv: {
        requestsMetadata: CreateCsvRequestBuilderRequestsMetadata,
    },
    getPath: {
        requestsMetadata: GetRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const FareRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: FareRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFareFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeFareCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    put: {
        uriTemplate: FareRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeFareUpdateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
